import React, { Component} from "react";
// Styles
import "./ProcLevelView.scss";


// Components
import HeaderView from "components/HeaderView";
// import Next from 'static/img/next.svg'
import  ProcLevel from "views/ProcLevel/ProcLevel";

class ProcLevelView extends Component {

  render() {
    return (
      <>
      <div className="level-view">
      <HeaderView/>
      < ProcLevel />
    </div>
      </>
    );
  }
}
export default ProcLevelView;
